import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/vendor_partners/Page";
import { useVendorPartners } from "~/hooks/vendors/useVendorPartners";

export const PATH = "/vendors/settings/vendor_partners";

const VendorPartnerSetting: NextPage = () => {
	const { data: vendorPartners } = useVendorPartners().index();

	if (vendorPartners === null) {
		return null;
	}

	return (
		<>
			<NskHead title="協力会社設定" />
			<Component vendorPartners={vendorPartners} />
		</>
	);
};

export default VendorPartnerSetting;
